import { Component, ViewChild, ElementRef, ɵConsole, WritableSignal, signal } from "@angular/core"; import { Location } from "@angular/common";
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { CleValeur, CleValeurNumerique } from '../entites/cleValeur';
import { EntreeCommande } from '../entites/entree-commande';
import { ItemMin } from '../entites/item-min';
import { Statut } from '../entites/statut';
import { DonneesBaseService } from '../services/donnees-base-service';
import { BaseComponent } from '../base/base-component';
import { ItemService } from '../services/item-service';
import { BlockUIModule } from 'primeng/blockui';
import { FournisseurService } from '../services/fournisseur-service';
import { Fournisseur } from '../entites/fournisseur';
import { EmployeEntite } from '../entites/employe';
import { ItemCommandeEntite } from '../entites/item-commande';
import { MessageService, MenuItem } from 'primeng/api';
import { Table } from 'primeng/table/table';
import { ProfilService } from '../services/profil-service';
import { ActivatedRoute, Router } from '@angular/router';
import { RequisitionService } from '../services/requisition-service';
import { AppMainComponent } from '../app.main.component';
import { CategorieEntite } from '../entites/categorie';
import { SignalWithWatcher } from '../services/base.service';
import { HttpEvent, HttpEventType } from "@angular/common/http";
export interface ParametresSelectionItemMultiple {
    itemIdsExclus?: number[];
}

export interface ResultatSelectionItemMultiple {
    items?: ItemMin[];
}

@Component({
    selector: 'app-selection-item-multiple',
    templateUrl: './selection-item-multiple.component.html'
})
export class SelectionItemMultipleComponent extends BaseComponent {


    //Général

    donnees: ParametresSelectionItemMultiple;

    submitted: boolean;
    
    menu: MenuItem[];

    itemsComplets: SignalWithWatcher<ItemMin[]>;
    items: SignalWithWatcher<ItemMin[]>;
    selectionItem: ItemMin[];

    loadingEvent: WritableSignal<HttpEvent<any>> = signal(null);
    loadingError: WritableSignal<string> = signal(null);

    @ViewChild('rechercheItem') inputRechercheItem;
    @ViewChild('dt') tableItems: Table;

    constructor(
        profilService: ProfilService,
        route: ActivatedRoute, 
        routerService: Router,
		appMain: AppMainComponent, location: Location, 
        public itemService: ItemService,
        public requisitionService: RequisitionService,
        public fournisseurService: FournisseurService,
        public messageService: MessageService,
        public ref: DynamicDialogRef,
        public config: DynamicDialogConfig,
        public sdb: DonneesBaseService) {
        super(sdb, profilService, route, routerService, appMain);
    }



    ngOnInit() {

        this.donnees = this.config.data;

        this.colonnesDisponibles = [
            { champ: 'categorie', entete: 'Catégorie', afficheParDefaut: true },
            { champ: 'sousCategorie', entete: 'Sous-catégorie', afficheParDefaut: true },
            { champ: 'marque', entete: 'Marque', afficheParDefaut: false },
            { champ: 'modele', entete: 'Modèle', afficheParDefaut: false }
        ];

        this.colonnesSelectionnees = this.colonnesDisponibles.filter(x => x.afficheParDefaut);

        this.itemService.ObtenirItems(null).subscribe({
            next: (x) => {
                if (x.type == HttpEventType.Response) {
                    this.itemsComplets.value.set(x.body.value().filter(x => x.categorie.estSuivi && !x.categorie.estUnique));
                    if (this.donnees.itemIdsExclus) {
                        this.items.value.set(this.itemsComplets.value().filter(x => !this.donnees.itemIdsExclus.includes(x.itemId)));
                    } else {
                        this.items.value.set(this.itemsComplets.value());
                    }

                    this.initialiserMenu();
                    
                    this.CompleterChargement();

                    setTimeout(() => { this.inputRechercheItem.nativeElement.focus(); }, 100);
                }
                this.loadingEvent.set(x);
            },
            error: (error) => {
                this.loadingError.set(error.error);
            }
        });

    }

    initialiserMenu() {
        this.menu = [
            {
                label: 'Annuler', icon: 'pi pi-fw pi-ban', command: () => this.ref.close(null)
            },
            {
                label: 'Sélectionner', icon: 'pi pi-fw pi-check', 
                disabled: !this.selectionItem || this.selectionItem.length == 0,
                command: () => this.surSelectionItemInventaire(this.selectionItem)
            }
        ];
    }

    surChangementSelection() {
        this.initialiserMenu();
    }

    surEntreeRecherche() {

        if (this.tableItems.filteredValue != undefined &&
            this.tableItems.filteredValue.length == 1) {
            this.surSelectionItemInventaire([this.tableItems.filteredValue[0]]);
        }

    }

    annuler() {
        this.ref.close(null);
    }

    surSelectionItemInventaire(items: ItemMin[]) {

        this.ref.close({
            items: items
        });

    }
}